import { useEffect } from "react";
import { ImageIcon } from "lucide-react";
import { usePostImage } from "@/lib/postMedia";

/**
 * PostThumb — 1:1 web port of iOS `mobile/src/components/PostThumb.tsx`.
 *
 * Square grid tile for a standard post.  The Profile_Fetch grid endpoints
 * (/standard_posts, /opinion_posts) return posts WITHOUT media fields, so
 * the image resolves lazily via `usePostImage` (cached per post id per
 * session).  A soft shimmer plays while it loads, then the photo fades
 * in.  When the fetch resolves with no image, a subtle placeholder icon
 * is shown instead of a blank square.
 */
export default function PostThumb({ post, onClick, testId }) {
  const { url, loading } = usePostImage(post);

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative w-full h-full bg-secondary overflow-hidden active:opacity-75 transition-opacity"
      data-testid={testId}
      aria-label="Open post"
    >
      {url ? (
        <img
          src={url}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
          draggable={false}
        />
      ) : loading ? (
        <Shimmer />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-secondary">
          <ImageIcon size={18} className="text-muted-foreground opacity-60" />
        </div>
      )}
    </button>
  );
}

function Shimmer() {
  useEffect(() => {
    // no-op — CSS animation handles the shimmer.
  }, []);
  return (
    <div
      className="absolute inset-0 bg-secondary"
      style={{
        animation: "postThumbShimmer 1.2s ease-in-out infinite",
      }}
    />
  );
}
